export function CopyText() {

  const Btn = $('.copyBtn');

  function Clicked() {
    Btn.addClass('tips');
  }
  function Reset() {
    Btn.removeClass('tips');
  }

  $(function () {
    Btn.click(function () {
      Clicked();
      setTimeout(() => {
        Reset()
      }, 3000);
    })
  });
}